
export const Styles = (theme) => ({
  main: {
    padding: (props) => (props.sm ? "15px 0px" : "15px 40px"),
    marginTop: 75,
    minHeight: "84vh"
  },
});
